/* Mega Outlet confetti (Shopify Files, loaded from a Custom liquid section in the footer).
   1. Home page: the orange "Mega's Outlet Shopping" tile bursts confetti the first time the mouse goes over it.
   2. /collections/outlet: a confetti shower when the page opens.
   Each fires once per browser visit (sessionStorage). Skipped for "reduce motion" users. No dependencies. */
(function () {
  'use strict';
  if (window.__mosConfetti) return; window.__mosConfetti = 1;
  try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}

  var COLOURS = ['#f47a10', '#ff9f43', '#0f2a5c', '#0f49a0', '#74b3ea', '#ffde1b', '#ffffff'];
  function once(key) {
    try { if (sessionStorage.getItem(key)) return false; sessionStorage.setItem(key, '1'); } catch (e) {}
    return true;
  }

  function burst(opts) {
    var c = document.createElement('canvas');
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000';
    document.body.appendChild(c);
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = innerWidth, H = innerHeight;
    c.width = W * dpr; c.height = H * dpr;
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var parts = [], n = opts.count || 140;
    for (var i = 0; i < n; i++) {
      var ang = opts.spread ? (opts.angle + (Math.random() - 0.5) * opts.spread) : Math.PI / 2;
      var sp = opts.speed ? opts.speed * (0.5 + Math.random()) : 2 + Math.random() * 3;
      parts.push({
        x: opts.x != null ? opts.x + (Math.random() - 0.5) * (opts.w || 0) : Math.random() * W,
        y: opts.y != null ? opts.y + (Math.random() - 0.5) * (opts.h || 0) : -20 - Math.random() * H * 0.4,
        vx: Math.cos(ang) * sp, vy: -Math.sin(ang) * sp * (opts.spread ? 1 : -1),
        w: 6 + Math.random() * 6, h: 8 + Math.random() * 8,
        r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3,
        tilt: Math.random() * Math.PI, vt: 0.05 + Math.random() * 0.1,
        col: COLOURS[(Math.random() * COLOURS.length) | 0], round: Math.random() < 0.25
      });
    }
    var start = performance.now(), life = opts.life || 2800;
    function frame(t) {
      var age = t - start; ctx.clearRect(0, 0, W, H);
      var fade = age > life - 600 ? Math.max(0, (life - age) / 600) : 1;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vy += 0.12; p.vx *= 0.99; p.vy *= 0.99; p.x += p.vx + Math.sin(p.tilt) * 0.6; p.y += p.vy;
        p.r += p.vr; p.tilt += p.vt;
        ctx.save(); ctx.globalAlpha = fade; ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.col;
        if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.283); ctx.fill(); }
        else ctx.fillRect(-p.w / 2, -p.h / 2 * Math.abs(Math.cos(p.tilt)), p.w, p.h * Math.abs(Math.cos(p.tilt)));
        ctx.restore();
      }
      if (age < life) requestAnimationFrame(frame); else c.remove();
    }
    requestAnimationFrame(frame);
  }

  function onOutletPage() { return /^\/collections\/outlet\/?$/.test(location.pathname); }

  function init() {
    if (onOutletPage() && once('mosConfettiOutletPage')) {
      setTimeout(function () { burst({ count: 180, life: 3200 }); }, 300);
    }
    var tile = document.querySelector('#MosBento .t-outlet');
    if (tile) {
      var fire = function () {
        tile.removeEventListener('mouseenter', fire);
        if (!once('mosConfettiOutletTile')) return;
        var b = tile.getBoundingClientRect();
        burst({ x: b.left + b.width / 2, y: b.top + b.height / 2, w: b.width * 0.8, h: b.height * 0.5,
          angle: Math.PI / 2, spread: Math.PI * 0.9, speed: 9, count: 120, life: 2400 });
      };
      tile.addEventListener('mouseenter', fire);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
